module.exports = __webpack_public_path__ + "img/RCloudSchemaReseau.1990e85f.png";